import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Stack,
} from "@mui/material";
import style from "../JobRoleDetails/jobRolesTable.module.scss";
import {
  GetAllAdminDetails,
  GetAllAdminName,
  getTargetData,
  putAdminTargetById,
  putTargetAmount,
} from "../../../../apiServices";
import { useSelector } from "react-redux";
import { dateFormateDD, formatMonthYear, getPercentageColor, MyModal } from "../../../../utility";
import ModalContainer from "../../../../components/modal_popup";
import SuccessTick from "../../../../components/success_tick";
import { BsPencilSquare } from "react-icons/bs";
import TargetPostForm from "./PostApi";
import TargetAnalyticsFilter from "./TargetAnalyticsFilter";
import { useDispatch } from "react-redux";
import { CandidateDashboardFilterActions } from "../../../../redux-store/store";
import { RiDeleteBinLine } from "react-icons/ri";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function TargetAnalyticsTable() {
  const Dispatch = useDispatch();
  const mothlyTargetFilter = useSelector(
    (state) => state.CandidateDashboardFilterDetails.AdminMonthlyTarget
  );
  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails.roleID === 1;

  const [targetData, setTargetData] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const [showTargetEdit, setShowTargetEdit] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [targetRemoveConfirmOpen, setTargetRemoveConfirmOpen] = useState(false);
  const [targetAmount, setTargetAmount] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [rowId, setRowId] = useState(null);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [totalPages, setTotalPages] = useState(1);

  const fetchTargetData = (page = 1) => {
    const filterData = { ...mothlyTargetFilter, page };



    getTargetData(filterData).then((res) => {
      console.log(res, "Data");

      if (res?.result?.target) {
        const processedData = res.result.target
          .map((row) => ({
            ...row,
            percentage:
              row.target_amount && row.total_ctc
                ? (Number(row.total_ctc) / Number(row.target_amount)) * 100
                : 0,
          }))
          .sort((a, b) => b.percentage - a.percentage);
        setTargetData(processedData);
       
        setTotalPages(res.totalPages || 1);
      }
    });
  };
  const handleRest = () => {
    getTargetData(mothlyTargetFilter).then((res) => {
      console.log(res, "Data");

      if (res?.result?.target) {
         const processedData = res.result.target
          .map((row) => ({
            ...row,
            percentage:
              row.target_amount && row.total_ctc
                ? (Number(row.total_ctc) / Number(row.target_amount)) * 100
                : 0,
          }))
          .sort((a, b) => b.percentage - a.percentage);
        setTargetData(processedData);
        setTotalPages(res.totalPages || 1);
      }
    });
  };


 

  useEffect(() => {
    fetchTargetData(mothlyTargetFilter.page);
  }, [mothlyTargetFilter, mothlyTargetFilter.page]);

  useEffect(() => {
    // console.log(analyticsData, "analyticsData");

    if (analyticsData?.target_amount) {
      setTargetAmount(parseInt(analyticsData.target_amount));
    }
  }, [analyticsData]);

  useEffect(() => {
    GetAllAdminName()
      .then((admins) => {
        const filtered = admins.filter(
          (admin) => !admin.Deactived && admin.Module !== "Developer"
        );
        setAdminList(filtered);
      })
      .catch(() => {
        alert("Something went wrong");
      });
  }, []);

  const getAdminUsername = (adminId) => {
    const admin = adminList.find((a) => a.id === adminId);
    return admin?.userName || "Taizo";
  };

  function candidatePagination(event, page) {
    const currentPage = page;

    Dispatch(
      CandidateDashboardFilterActions.setAdminMonthlyTargetPage(currentPage)
    );
  }

  const handleReset = () => {
    fetchTargetData(mothlyTargetFilter.page);
  };

  const updateTargetAmount = async (e) => {
    e.preventDefault();
    const payload = {
      id: rowId,
      target_amount: Number(targetAmount),
    };
    try {
      await putTargetAmount(payload);
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        setShowTargetEdit(false);
        handleReset();
      }, 2000);
    } catch (err) {
      alert("Update failed");
    }
  };
  const currentMonthYear = `${
    months[new Date().getMonth()]
  } ${new Date().getFullYear()}`;

  const handleDeleteTarget = async (id) => {
    setEnableSubmit(true);

    try {
      await putAdminTargetById(id);
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        setTargetRemoveConfirmOpen(false);
        setEnableSubmit(false);
        handleReset();
      }, 2000);
    } catch (err) {
      alert("Update failed");
      setEnableSubmit(false);
    }
  };

  return (
    <>
      <div className="mb-1 d-flex justify-content-between align-items-center">
        <div></div>
        <div style={{ fontSize: "18px" }}>
          <b>{formatMonthYear(mothlyTargetFilter.startDate)}</b>
        </div>
        <div className="d-flex gap-2">
          <TargetPostForm onclose={handleRest} />
          <TargetAnalyticsFilter />
        </div>
      </div>

      <TableContainer style={{ height: "64vh", overflowY: "auto" }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {[
                "SI.NO",
                "Recruiter Name",
                "Target",
                "Achieved",
                "Balance Target",
                "Over Target",
                "Remove",
              ].map((title, i) => (
                <TableCell
                  key={i}
                  sx={{ backgroundColor: "#16629cff", color: "#fff" }}
                >
                  <strong>{title}</strong>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {targetData.length > 0 ? (
              targetData.map((row, index) => (
                <TableRow
                  key={row.id}
                  className={style["table-row"]}
                  onClick={() => setAnalyticsData(row)}
                   sx={{ backgroundColor:`${getPercentageColor(row.percentage)}`, color: "#fff" }}
                >
                  <TableCell sx={{ padding: "10px 12px" }}>
                    {(mothlyTargetFilter.page - 1) * 10 + index + 1}
                  </TableCell>
                  <TableCell>{getAdminUsername(row.admin_id)}</TableCell>
                  <TableCell>
                    <div
                      className="d-flex align-items-center"
                      style={{ cursor: "pointer" }}
                    >
                      <BsPencilSquare
                        className="text-success me-2 fs-5"
                        onClick={(e) => {
                          e.stopPropagation();
                          setRowId(row.id);
                          setShowTargetEdit(true);
                          setAnalyticsData(row);
                        }}
                      />
                      ₹
                      {row.target_amount
                        ? Number(row.target_amount).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : "-"}

                    </div>
                  </TableCell>
                  <TableCell>
                    ₹
                    {row.total_ctc
                      ? Number(row.total_ctc).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : 0}
     
                  
                      &nbsp;

                      {row.target_amount && row.total_ctc
                        ? (
                          <strong style={{ color: getPercentageColor(row.percentage, "dark") }}>
                          {" (" +
                            (
                            (Number(row.total_ctc) / Number(row.target_amount)) * 100
                            ).toLocaleString("en-IN", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                            }) +
                            "%)"}
                          </strong>
                        )
                        : ""}
                    {/* {row.total_ctc ?? 0} */}
                  </TableCell>
                  <TableCell>
                    ₹
                    {row.target_amount > row.total_ctc
                      ? (
                          Number(row.target_amount || 0) -
                          Number(row.total_ctc || 0)
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : 0}
                  </TableCell>
                  <TableCell>
                    {row.target_amount < row.total_ctc
                      ? (
                          Number(row.total_ctc || 0) -
                          Number(row.target_amount || 0)
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : 0}
                  </TableCell>
                  <TableCell>
                    <RiDeleteBinLine
                      className="text-danger fs-5"
                      cursor={"pointer"}
                      onClick={() => {
                        setTargetRemoveConfirmOpen(true);
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={5}
                  align="center"
                  sx={{
                    height: "60vh",
                    verticalAlign: "middle",
                    fontWeight: 500,
                    color: "#666",
                  }}
                >
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          backgroundColor: "#fff",
          padding: "10px 0",
          boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
          zIndex: 10,
        }}
      >
        <Stack direction="row" justifyContent="center">
          <Pagination
            // count={10}
            shape="rounded"
            siblingCount={1}
            boundaryCount={1}
            count={totalPages}
            // variant="outlined"
            color="success"
            onChange={candidatePagination}
          />
        </Stack>
      </div>

      {showTargetEdit && (
        <MyModal>
          <ModalContainer
            childComponent={
              <form style={{ width: "400px" }} onSubmit={updateTargetAmount}>
                <div className="text-center mb-3">
                  <strong>Update Target Amount</strong>
                </div>
                <div className="mb-3">
                  <label htmlFor="targetAmount" className="form-label">
                    Enter target amount:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="targetAmount"
                    value={targetAmount}
                    onChange={(e) => setTargetAmount(e.target.value)}
                    maxLength={7}
                    required
                    min={0}
                    pattern="\d+"
                    title="Please enter a valid CTC (numbers only)."
                  />
                </div>
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    onClick={() => setShowTargetEdit(false)}
                    className="btn btn-danger"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-success">
                    Update
                  </button>
                </div>
              </form>
            }
          />
        </MyModal>
      )}
      {targetRemoveConfirmOpen && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <div>
                  Are you sure you want to delete the target for{" "}
                  <b>{getAdminUsername(analyticsData.admin_id)}</b>?
                </div>
                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button
                    type="button"
                    onClick={() => {
                      setTargetRemoveConfirmOpen(false);
                      setEnableSubmit(false);
                    }}
                    className="btn btn-danger"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success"
                    onClick={() => {
                      handleDeleteTarget(analyticsData.id);
                    }}
                    disabled={enableSubmit}
                  >
                    Delete
                  </button>
                </div>
              </>
            }
          />
        </MyModal>
      )}

      {showSuccess && (
        <MyModal>
          <ModalContainer
            childComponent={<SuccessTick HeadText="Successfully Updated" />}
          />
        </MyModal>
      )}
    </>
  );
}

export default TargetAnalyticsTable;
